import { Box, Spinner, Text } from '@chakra-ui/react'
import { useStore } from '@tanstack/react-store'
import { api } from 'api'
import { useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { authStore } from 'shared/store/auth'

export const Logout = () => {
  const { isAuthenticated } = useStore(authStore)

  useEffect(() => {
    if (isAuthenticated) {
      api.auth.logout()
    }
  }, [isAuthenticated])

  return isAuthenticated ? (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      alignContent="center"
      alignItems="center"
      padding="60px"
    >
      <Text>Выход...</Text>
      <Spinner color="blue.500" size="md" marginTop="20px" />
    </Box>
  ) : (
    <Redirect to="/" />
  )
}
